module.exports = __webpack_public_path__ + "1791188489487/images/file-slash.b1dcccd.svg";